import * as React from "react";
import * as icons from "../../icons";
import join from "../../utils/join-path";
import Sidebar from "../sidebar/Sidebar";
import SidebarLink from "../sidebar/SidebarLink";
import SidebarDivider from "../sidebar/SidebarDivider";

const AdminSidebar = ({ match }) => (
  <Sidebar>
    <SidebarLink
      to={join(match.url, "/dashboard")}
      icon={icons.DASHBOARD}
      text="Dashboard"
    />
    <SidebarLink
      to={join(match.url, "/jobs")}
      icon={icons.FOLDER}
      text="Jobs"
    />
    <SidebarLink
      to={join(match.url, "/reports")}
      icon={icons.SHOW_CHART}
      text="Reports"
    />
    <SidebarDivider />
    <SidebarLink
      to={join(match.url, "/franchises")}
      icon={icons.STORE_MALL_DIRECTORY}
      text="Franchises"
    />
    <SidebarLink
      to={join(match.url, "/transmittal-templates")}
      icon={icons.BUILD}
      text="Transmittal Templates"
    />
    <SidebarLink
      to={join(match.url, "/users")}
      icon={icons.PEOPLE}
      text="Users"
    />
    <SidebarLink
      to={join(match.url, "/holidays")}
      icon={icons.CALENDAR}
      text="Holidays"
    />
  </Sidebar>
);

export default AdminSidebar;



// WEBPACK FOOTER //
// ./src/components/admin/Sidebar.js